import { useTranslation } from 'react-i18next'
import { DataItem, connect } from 'scrivito'

import { Icon } from '@/Atomic/Atoms/Icon'
import { StringText } from '@/Atomic/Atoms/StringText'
import { MenuItemProps } from '@/Atomic/Molecules/MenuItem'
import { DropdownMenu } from '@/Atomic/Organisms/DropdownMenu'
import { DocumentDocumentRelation } from '@/Data/DocumentDocumentRelation/DocumentDocumentRelationDataClass'

interface DocumentFolderBoxProps {
  document: DataItem
  onClick: (e: React.MouseEvent) => void

  title: string | null
  menuItems: MenuItemProps[]
}
export const DocumentFolderBox: React.FC<DocumentFolderBoxProps> = connect(
  ({ document, onClick, title, menuItems }) => {
    const { t } = useTranslation()
    const id = document.id()

    const count =
      DocumentDocumentRelation.all()
        .transform({ filters: { father: id } })
        .count() || 0

    const folderName = title || 'Folder'

    return (
      <div className="document-folder-box" onClick={(e) => onClick(e)}>
        <div className="content">
          <div className="box-header">
            <Icon className="folder-closed" icon="folder" />
            <Icon className="folder-opened" icon="folder-open" />
            <DropdownMenu
              className="box-menu"
              menuItems={menuItems}
              boundarySelector=".documents-tab ul"
            />
          </div>
          <StringText
            wrapperClassName="title"
            variant="title"
            value={folderName}
          />
        </div>
        <div className="counter">
          <StringText
            variant="subtitle"
            value={
              count === 1
                ? t('components.document.element')
                : t('components.document.elements', { count })
            }
          />
        </div>
      </div>
    )
  },
)
